import Configs from 'utils/Configs';

const dark = {
  primary: '#111',
  colorApp: '#339966',
  secondary: 'white',
  card: '#2C2C2E',
  buttonText: 'white',
  button: '#5b3b24',
  placeholder: '#666',
  text: '#EEE',
  text1: '#AAA',
  textTitle: '#FFF',
  border: '#555',
  box: '#222',
  background: '#111',
  background1: '#161616',
  shadow: '#222',
  headerText: '#EEE',
  borderBox: '#FFF',
  header: '#2a2b2b',
  error: '#E03D1D',
  vip: '#FFCC00'
};

const light = {
  ...dark,
  primary: '#339966',
  colorApp: '#339966',
  secondary: 'white',
  card: '#FFFFFF',
  buttonText: 'white',
  button: '#5b3b24',
  placeholder: '#666',
  text: '#333',
  text1: '#444',
  textTitle: '#111',
  border: '#CCC',
  box: '#EDEDED',
  background: '#DDD',
  background1: '#D6D6D6',
  shadow: '#111',
  borderBox: '#DDD',
  header: '#e3e3e3'
};

const Colors = {
  change: () => {
    let theme = light;
    if (Configs.darkMode) theme = dark;
    let keys = Object.keys(theme);
    for (var i = 0; i < keys.length; i += 1) {
      let key = keys[i];
      Colors[key] = theme[key];
    }
  },
  ...light,
  getDebtColor: (debt) => {
    debt = parseInt(debt);
    if (debt === 0) return Colors.text1;
    return debt > 0 ? 'red' : Colors.colorApp;
  },
  moneyColors: ['#336633', '#FF9966', '#6633FF']
};

export default Colors;
